import React from 'react';
import { Button } from './ui/Button';
import { LiveSlackFeed } from './hero/LiveSlackFeed';
import { EmailCaptureForm } from './ui/EmailCaptureForm';
interface HeroProps {
  onGetStarted: (email: string) => void;
  isSubmitted: boolean;
  submittedEmail: string;
}
export const Hero = ({
  onGetStarted,
  isSubmitted,
  submittedEmail
}: HeroProps) => {
  return <section className="w-full min-h-screen flex items-center relative overflow-hidden bg-gradient-to-b from-[#F5F8FF] to-white" data-id="element-34">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-35">
        <div className="text-center pt-[100px] md:pt-[140px]" data-id="element-36">
          <div className="fade-in-slide-up" data-id="element-37">
            <h1 className="font-bold text-gray-900 leading-[1.1] tracking-[-0.02em] max-w-[1200px] mx-auto mb-4 md:mb-6" style={{
            fontSize: 'clamp(2.5rem, 8vw, 4.5rem)'
          }} data-id="element-38">
              Build Better Culture{' '}
              <span className="text-[#8679DF]" data-id="element-39">With Data</span>
            </h1>
            <p className="text-gray-700 font-normal leading-[140%] max-w-[900px] mx-auto mb-8 md:mb-10" style={{
            fontSize: 'clamp(1rem, 3vw, 1.625rem)'
          }} data-id="element-40">
              Contextuality analyzes everyday team conversations and delivers
              live culture metrics with concise leadership guidance—helping
              distributed teams stay aligned, resilient, and high-performing.
            </p>
            <div className="flex justify-center mb-16" data-id="element-41">
              <EmailCaptureForm onSubmit={onGetStarted} isSubmitted={isSubmitted} submittedEmail={submittedEmail} data-id="element-42" />
            </div>
            <LiveSlackFeed data-id="element-43" />
          </div>
        </div>
      </div>
    </section>;
};